<form name="recForm" class="height-100 gray-bg">
  <div class="wrapper wrapper-content">
    <div class="ibox">
      <div class="ibox-title">
        <h2>Recomendação de Semeadura</h2>
      </div>

      <!-- Status -->
      <div class="ibox-content">
        <div class="row">
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <label for="status" class="control-label">Status</label>
              <select name="status" id="status" class="form-control" ng-model="recomendacaoSemeadura.data.status">
                <option value="rascunho">Rascunho</option>
                <option value="publicado">Pronto para executar</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6">
            <div class="form-group">
              <label for="situacao" class="control-label">Situação</label>
              <select name="situacao" id="situacao" class="form-control" ng-model="recomendacaoSemeadura.data.situacao"
                ng-disabled="recomendacaoSemeadura.data.status != 'publicado'">
                <option value="aberto">Aberto</option>
                <option value="em_andamento">Em Andamento</option>
                <option value="finalizado">Finalizado</option>
              </select>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="tabs-container">

          <!-- Abas de configuração -->
          <uib-tabset active="recomendacaoSemeadura.activeTab" class="recomendacao-semeadura-tabs">

            <!-- Parâmetros -->
            <uib-tab>
              <uib-tab-heading>
                <i class="fa fa-cogs"></i>
                Parâmetros
                <i class="fa fa-exclamation text-warning" ng-if="!recomendacaoSemeadura.validTab('parametros')"></i>
              </uib-tab-heading>
              <ng-include src="'views/recomendacao_semeadura/tabs/parametros_tab.html'"></ng-include>
            </uib-tab>

            <!-- Glebas -->
            <uib-tab disable="!recomendacaoSemeadura.shouldActiveTab('glebas')">
              <uib-tab-heading>
                <i class="fa fa-map"></i>
                Talhões
                <i class="fa fa-exclamation text-warning" ng-if="!recomendacaoSemeadura.validTab('glebas')"></i>
              </uib-tab-heading>
              <ng-include src="'views/recomendacao_semeadura/tabs/glebas_tab.html'"></ng-include>
            </uib-tab>

            <!-- Tratamento de Sementes -->
            <uib-tab disable="!recomendacaoSemeadura.shouldActiveTab('tratamento')">
              <uib-tab-heading>
                <i class="fa fa-map"></i>
                Tratamento de sementes
                <i class="fa fa-exclamation text-warning" ng-if="!recomendacaoSemeadura.validTab('tratamento')"></i>
              </uib-tab-heading>
              <semeadura-tratamento cultivares-tratamento="recomendacaoSemeadura.cultivaresTratamento"
                cultivares-destino-tratamento="recomendacaoSemeadura.cultivaresDestinoTratamento"
                recomendacao="recomendacaoSemeadura.data" is-corn="recomendacaoSemeadura.isCulturaPorUnidade">
              </semeadura-tratamento>
            </uib-tab>

            <!-- Adubação -->
            <uib-tab disable="!recomendacaoSemeadura.data.glebas.length">
              <uib-tab-heading>
                <i class="icon-fertilizer"></i>
                Adubação
              </uib-tab-heading>
              <ng-include src="'views/recomendacao_semeadura/tabs/adubos_tab.html'"></ng-include>
            </uib-tab>

            <!-- Mapa -->
            <uib-tab disable="!recomendacaoSemeadura.data.propriedade" select="recomendacaoSemeadura.createMap()">
              <uib-tab-heading>
                <i class="fa fa-map"></i>
                Mapa
              </uib-tab-heading>

              <div class="panel-body map-tab">
                <ng-include hidden src="'views/recomendacao_semeadura/tabs/print_map.html'"></ng-include>
                <button
                  ng-if="
                    recomendacaoSemeadura.map &&
                    recomendacaoSemeadura.mapLegend.length &&
                    recomendacaoSemeadura.svgPolygons"
                  type="button"
                  class="btn btn-print-map"
                  ng-print
                  print-element-id="print-map"
                  title="Imprimir talhões"
                >
                  <i class="fa fa-print"></i>
                </button>
                <div id="recommendation_map"></div>
                <agro-legenda-mapa
                  on-mouse-over="recomendacaoSemeadura.cultivarMouseOver(legenda)"
                  on-mouse-out="recomendacaoSemeadura.cultivarMouseOut(legenda)"
                  legendas="recomendacaoSemeadura.mapLegend" />
              </div>
            </uib-tab>
            <!-- Resumo -->
            <uib-tab>
              <uib-tab-heading>
                <i class="fa fa-check"></i>
                Resumo/Confirmação
              </uib-tab-heading>
              <ng-include src="'views/recomendacao_semeadura/tabs/resumo_tab.html'"></ng-include>
            </uib-tab>
          </uib-tabset>

        </div>
      </div>
    </div>
    <div class="ibox">
      <div class="ibox-content clearfix">
        <a href="#!/recomendacoes_semeadura" class="btn btn-info">Voltar</a>
        <div class="btn-group pull-right">
          <button type="button" class="btn btn-link" id="print-btn" ng-print print-element-id="print-recomendacao"
            ng-disabled="recomendacaoSemeadura.mainSaveDisabled()">
            <i class="fa fa-print"></i>
            Imprimir
          </button>
          <button type="button" class="btn btn-primary" ng-click="recomendacaoSemeadura.save()"
            ng-disabled="recomendacaoSemeadura.mainSaveDisabled()">
            <i class="fa fa-check"></i>
            Gravar
          </button>
          <p class="text-danger" ng-if="recomendacaoSemeadura.mainSaveDisabled()">Preencha todos os dados obrigatórios.
          </p>
        </div>
      </div>
    </div>
  </div>
</form>
